module.exports = __webpack_public_path__ + "static/media/second_irwin_conference_center1.e6020cbf.jpeg";